import * as React from "react";
import WishlistContext from "../services/WishlistContext";
import WishlistService from "../services/WishlistService";
import NotificationType from "./notification/NotificationType";
import useNotification from "./notification/useNotification";
import { IWishlistItem } from "../models/IWishlistItem.model";
import QuantityPicker from "../components/QuantityPicker";

function WishlistCard(props: IWishlistItem) {

	const wishlistService = new WishlistService();
	const wishlistContext = React.useContext(WishlistContext);
	const { addNotification } = useNotification();
	const [isLoading, setIsLoading] = React.useState(false);
	const wishlistCardRef = React.useRef<any>(null);

	React.useEffect(() => {
		if (wishlistCardRef.current) {
			wishlistCardRef.current.product = JSON.parse(props.Product.ModelJson);
		}
	}, [props.Product.ModelJson]);

	function handleRemoveFromWishlist() {

		setIsLoading(true);
		wishlistService.removeFromWishlist(props.LineItemGuid).then((data) => {
			wishlistService.trackRemoveFromWishlist({
				DisplayName: props.Product.DisplayName,
				Id: props.Product.Name,
				Price: props.Product.Price,
				Quantity: props.Quantity
			});
			wishlistService.setWishlistSummaryCount(data._embedded.wishlist.TotalItemQuantity);
			wishlistContext.setWishlist(data._embedded.wishlist);
			wishlistService.setBasketSummaryCount(data._embedded.basketsummary.TotalItemQuantity);
		})
		.catch(() => {
			addNotification({
				headline: 'Removing the product to your wishlist was unsuccessful. Please try again.',
				type: NotificationType.error
			});
			setIsLoading(false);
		});
		
	}


	function handleMoveToBasket() {

		setIsLoading(true);
		wishlistService.moveItemToBasket(props.LineItemGuid, props.Quantity).then((data) => {
			wishlistService.setWishlistSummaryCount(data._embedded.wishlist.TotalItemQuantity);
			wishlistContext.setWishlist(data._embedded.wishlist);
			wishlistService.setBasketSummaryCount(data._embedded.basketsummary.TotalItemQuantity);
			wishlistService.trackMoveToBasket([props]);
		}).catch(() => {
			addNotification({
				headline: 'Moving the product to your wishlist was unsuccessful. Please try again.',
				type: NotificationType.error
			});
			setIsLoading(false);
		});

	}

	function slot(name = "") {
		return {
			ref: (e) => {
				if (e) {
					e.setAttribute("slot", name);
				}
				
			}
		};
	}

	return (
		<product-card
			type="wishlist"
			ref={wishlistCardRef}
			isLoading={isLoading}
			test="wishlist-product"
			info="WishlistCard.tsx">
			<div slot="wishlist-button">
				<div className="c-product__wishlist-button js-add-to-wishlist-container">
				<button type="button" className="c-wishlist-add-button" data-in-wishlist="true" onClick={() => handleRemoveFromWishlist()} data-test="wishlist-product-card-add-to-wishlist-button">
					<span className="c-wishlist-add-button__text js-add-to-wishlist-text u-visuallyhidden">Remove {props.Product.DisplayName} from wishlist</span>
					<img src="/images/icons/svgs/wishlist-filled.svg?v=20855" className="c-icon c-wishlist-add-button__heart-full" height="24" width="24" loading="lazy" alt="" />
					</button>
				</div>
			</div>
			<div slot="footer">
				<div className="c-product__action">
					<QuantityPicker {...props} setLoading={setIsLoading} isLoading={isLoading} />
					<React.Fragment>
					{props.HasVariants ?
						<a href={`${props.Product.Url}?wishlist=true&quantity=${props.Quantity}`} className="c-button c-button--full" data-test="wishlist-product-card-choose-an-option-button">Choose an option</a>
						: <button className="c-button c-button--full js-product-link" disabled={!props.CanBeAddedToBasket} onClick={() => handleMoveToBasket()} data-test="wishlist-product-card-move-to-basket">Move to Basket</button> }
					</React.Fragment>
				</div>
			</div>
		</product-card>
	);

}

export default WishlistCard;
